<div class="buildings-wrapper">
    @if (propertyInformation()?.existingBuildings?.length > 0) {
    <buildings-accordions [maxToShow]="10" [propertyInformation]="propertyInformation()?.existingBuildings"> </buildings-accordions>
    } @if (propertyInformation()?.historicBuildings?.length > 0) {
    <div class="column-100 history-wrapper">
        <div class="tinyinfo-container component-accordion">
            <div class="header" [class.expanded]="historyExpanded" (click)="historyExpanded = !historyExpanded">
                <div class="header-info">
                    <div class="column-50 section start">
                        <div class="overflow-hide">
                            <h2>Historikk</h2>
                        </div>
                    </div>
                    <div class="column-50 section space desktop-view">
                        <div class="icon-pannel">
                            <span title="Historikk" class="counter" [ngClass]="{ expanded: historyExpanded }">
                                {{ numberOfHistoricBuildings() }}
                            </span>
                        </div>
                    </div>
                </div>
                <ev-expanded-icon [expanded]="historyExpanded" [size]="22" [padding]="'0px 35px 0px 0px'"></ev-expanded-icon>
            </div>
            <div class="content-build" [class.expanded]="historyExpanded">
                <buildings-accordions [maxToShow]="10" [propertyInformation]="propertyInformation()?.historicBuildings"> </buildings-accordions>
            </div>
        </div>
    </div>
    }
</div>
